const HOMEPAGE_PATHS = ['/', '/v8', '/v8/']

export const isHomepageRoute = (path: string): boolean =>
  HOMEPAGE_PATHS.includes(path)
